<template>
  <div class="v2-our-story">
    <div class="wrapper">
      <h2 class="mb-3 mb-lg-4">
        {{ t("Our story") }}
      </h2>
      <div class="content">
        <div class="video mb-3 mb-lg-0">
          <div class="player-wrapper">
            <lazy-player id="our-story" :source="videoSrc" :poster="poster" ratio="16x9" />
            <like-button v-modal.modal-signup />
          </div>
        </div>
        <div class="description">
          <h4 class="mb-1 mb-lg-3">
            {{ t("3 amateurs, 1 camera") }}
          </h4>
          <div
            class="mb-3"
            v-html="
              t(
                'What started as friends making porn in a messy bedroom has grown into an amazing team of filmmakers, magic-making producers, and pleasure activists. Our best achievement? We`ve turned hundreds of fantasies into reality and made Ersties a <b>library of sex dreams.</b>',
              )
            "
          />
          <router-link to="/about_us" class="link-dark link-underline" @click="trackClick">
            {{ t("Get to know us more intimately") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { getWhoWeAreVideoUrl } from "@/utils/mediaHelper";
import LikeButton from "@/components/v2/like-button/index.vue";
import { amplitudeButtonClickTrack } from "@/utils/amplitude";
import { useRoleStore } from "@/store/role.ts";
import { ROLE_CENSORED_TOKEN } from "@/utils/variables.ts";
import { getRandomCensoredImage } from "@/utils/censorHelper.ts";
import ourStoryPoster from "@/assets/v2/images/our_story_poster.png";
import LazyPlayer from "@/components/lazy-player/index.vue";

defineOptions({
  name: "our-story",
});

const { locale, t } = useI18n();

const roleStore = useRoleStore();
const poster = computed(() => (roleStore.hasRole(ROLE_CENSORED_TOKEN) ? getRandomCensoredImage() : ourStoryPoster));

const videoSrc = computed(() => {
  return getWhoWeAreVideoUrl(locale.value === "de" ? "de" : "en");
});

const trackClick = () => {
  amplitudeButtonClickTrack("get more about us");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
